const RESOLVE_PATH = "/redirect/resolve";

interface RedirectResolutionResponse {
  redirectUrl?: unknown;
}

/** HTTP is accepted for the resolver's QA storefront fixtures. */
export function isSafeAppRedirectUrl(value: string): boolean {
  try {
    const url = new URL(value);
    return (
      (url.protocol === "https:" || url.protocol === "http:") &&
      !url.username &&
      !url.password
    );
  } catch {
    return false;
  }
}

export interface ResolveAppRedirectUrlInput {
  apiBaseUrl: string;
  clientId: string;
  locale: string;
}

export async function resolveAppRedirectUrl({
  apiBaseUrl,
  clientId,
  locale,
}: ResolveAppRedirectUrlInput): Promise<string> {
  const response = await fetch(
    `${apiBaseUrl.replace(/\/$/, "")}${RESOLVE_PATH}`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ clientId, locale }),
    },
  );

  if (!response.ok) {
    throw new Error(`Redirect resolve failed with status ${response.status}`);
  }

  const data = (await response.json()) as RedirectResolutionResponse;
  if (
    typeof data.redirectUrl !== "string" ||
    !isSafeAppRedirectUrl(data.redirectUrl)
  ) {
    throw new Error("Redirect resolve returned an unsafe URL");
  }

  return data.redirectUrl;
}
